import React, { useState } from "react";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/Sheet";
import { Button } from "../ui/Button";
import { IoMenu } from "react-icons/io5";
import styles from "./Navbar.module.css";
import { RouteAction } from "../../Reducer";
import {
  PublishIssue,
  RouteState,
} from "../../api/edits/editRoute.responses";
import { useAuth } from "../../hooks/useAuth";
import useEditRouteService from "../../api/edits/editRoute.service";
import { useNavigate } from "react-router-dom";
import ExitModal from "./ExitModal";
import { useSaveRoute } from "../../hooks/useSaveRoute";
import { toast } from "sonner";

interface MenuProps {
  routeDispatch: React.Dispatch<RouteAction>;
  routeState: RouteState;
  currentLanguage: string;
  setCurrentLanguage: React.Dispatch<React.SetStateAction<string>>;
  stateSelected: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
  setPublishIssues: React.Dispatch<React.SetStateAction<PublishIssue[]>>;
  setIsIssuesDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function Menu({
  routeDispatch,
  routeState,
  setCurrentLanguage,
  setSelected,
  setPublishIssues,
  setIsIssuesDialogOpen,
}: MenuProps) {
  const { isLoggedIn, logout } = useAuth();
  const { publishRoute, checkPublishReadiness } = useEditRouteService();
  const navigate = useNavigate();

  const { handleSaveRoute } = useSaveRoute(
    routeState,
    routeDispatch,
    setCurrentLanguage,
    setSelected
  );

  const [isPublishing, setIsPublishing] = useState(false);

  const handleMoveRouteToLive = async () => {
    setIsPublishing(true);
    try {
      const readiness = await checkPublishReadiness(routeState.id);

      if (!readiness.data.isReady) {
        setPublishIssues(readiness.data.issues);
        toast.error("Route is not ready to publish", {
          action: {
            label: "Show issues",
            onClick: () => { setIsIssuesDialogOpen(true); },
          },
          duration: 10000, 
        });
        return;
      }

      await publishRoute(routeState.id);
      navigate("/route-select");
    } catch (error: any) {
      toast.error(
        `Publish failed: ${error?.response?.data?.message ?? error?.message ?? "Unknown error"}`
      );
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className={styles.menuButton}>
          <IoMenu className={styles.menuIcon} />
        </button>
      </SheetTrigger>
      <SheetContent side="left">
        <SheetHeader>
          <SheetTitle>Options</SheetTitle>
        </SheetHeader>
        <SheetDescription>some options</SheetDescription>
        <div className="flex-col pt-8 justify-between gap-y-3">
          <SheetClose asChild>
            <Button type="submit" size="full" onClick={handleSaveRoute}>
              Save changes
            </Button>
          </SheetClose>
          <Button
            className="my-10"
            variant={"secondary"}
            type="submit"
            size="full"
            disabled={isPublishing}
            onClick={handleMoveRouteToLive}
          >
            {isPublishing ? "Publishing..." : "Change to live"}
          </Button>
        </div>

        <SheetFooter className="mt-48 flex flex-col">
          <ExitModal />
          {isLoggedIn() && (
            <>
              <Button
                variant="destructive"
                size="full"
                onClick={() => logout()}
              >
                Logout
              </Button>
            </>
          )}
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}

export default Menu;
